import { defineMessages } from 'react-intl-next';

export default defineMessages({
    title: {
        defaultMessage: '{requestTypeName} - {portalName} - Jira Service Management',
        description: 'Page title for request create page',
        id: 'cv.jsm.request.create.page.title',
    },
});
